export const ERROR_CODE = {
    // 网络错误
    NETWORK_ERROR: 4000,
};

export const SERVER_ERROR_CODE = {
    // ACCESS_TOKEN无效
    ACCESS_TOKEN_INCORRECT: 40003,
};
